import { useAthosContext } from 'libs/athos/fetchers/provider'
import { useOption } from 'libs/athos/hooks/useOption'
import { PaginationControls } from 'libs/athos/components/PaginationControls'

export function Pagination() {
  const { results, refine } = useAthosContext()

  const activePage = useOption('page', {
    defaultValue: 1,
    syncWithURL: true
  })

  return (
    <PaginationControls
      activePage={activePage}
      totalPages={results?.pagination?.totalPages ?? 1}
      onPageChange={(page) => refine('page', page)}
    />
  )
}
